class Contact {
  inputParts = ['#name', '#email', '#message'];

  registEvents() {
    for (let id of this.inputParts) {
      const elem = document.querySelector(id);
      elem.addEventListener('input', function(e) {
        let label = this.parentNode.querySelector('label');
        this.value.length > 0
          ? label.classList.add('del')
          : label.classList.remove('del');
      });
      this.triggerEvent(elem, 'input');
    }
  }

  setOptimizedResizeEvent = () => {
    const throttle = function(type, name, obj) {
      const objAttached = obj || window;
      let running = false;
      const func = function() {
        if (running) {
          return;
        }
        running = true;
        requestAnimationFrame(() => {
          objAttached.dispatchEvent(new CustomEvent(name));
          running = false;
        });
      };
      objAttached.addEventListener(type, func);
    };

    /* init - you can init any event */
    throttle('resize', 'optimizedResize');
  };

  triggerEvent = (element, event) => {
    if (document.createEvent) {
      // IE以外
      const evt = document.createEvent('HTMLEvents');
      evt.initEvent(event, true, true); // event type, bubbling, cancelable
      return element.dispatchEvent(evt);
    }
    // IE
    const evt = document.createEventObject();
    return element.fireEvent(`on${event}`, evt);
  };
}

/* eslint-disable */
const contact = new Contact();
/* eslint-enable */
// contact.registEvents();
